import { useReveal } from "@/hooks/useReveal";

const ROWS = [
  { format: "Single-serve sachet", sugar: true, cocoa: false },
  { format: "Doypack with zip, 250 g – 1 kg", sugar: true, cocoa: true },
  { format: "Retail pouch or carton, 500 g – 1 kg", sugar: true, cocoa: true },
  { format: "Foodservice bag, 5 kg", sugar: true, cocoa: true },
  { format: "Bulk sack, 25 kg", sugar: true, cocoa: true },
];

function Cell({ value }: { value: boolean }) {
  return value ? (
    <span className="inline-flex w-8 h-8 items-center justify-center rounded-full bg-brand/10 text-brand">
      <i className="ri-check-line text-lg"></i>
    </span>
  ) : (
    <span className="inline-flex w-8 h-8 items-center justify-center text-brown/40">
      <i className="ri-subtract-line text-lg"></i>
    </span>
  );
}

export default function WhatWePack() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="what-we-pack" className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center max-w-2xl mx-auto">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            What we can pack for you
          </h2>
          <p className="mt-3 text-ink/70 text-lg">
            Two products, several formats. Mixed pallets are possible within
            the same container.
          </p>
        </div>

        <div className="mt-12 overflow-x-auto">
          <table className="w-full min-w-[560px] border-collapse text-left">
            <thead>
              <tr className="border-b-2 border-cream-dark">
                <th className="py-4 pr-6 text-ink/60 text-sm font-semibold uppercase tracking-wider">
                  Format
                </th>
                <th className="py-4 pr-6 text-ink font-serif text-base md:text-lg font-semibold">
                  Organic whole cane sugar
                </th>
                <th className="py-4 text-ink font-serif text-base md:text-lg font-semibold">
                  Organic cocoa powder
                </th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr
                  key={row.format}
                  className="border-b border-cream-dark/60 last:border-0"
                >
                  <td className="py-4 pr-6 text-ink/80 text-[17px]">
                    {row.format}
                  </td>
                  <td className="py-4 pr-6">
                    <Cell value={row.sugar} />
                  </td>
                  <td className="py-4">
                    <Cell value={row.cocoa} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10 space-y-3 max-w-3xl">
          <p className="text-ink/70 text-[17px] leading-relaxed">
            Cane sugar is available pulverised, granulated and in sachet. Also
            known as non-centrifugal cane sugar (NCS), whole cane sugar,
            unrefined cane sugar, muscovado-type, jaggery, or panela in Latin
            America.
          </p>
          <p className="text-ink/70 text-[17px] leading-relaxed">
            Cocoa powder is supplied at 15% fat, with no added sugar.
          </p>
        </div>
      </div>
    </section>
  );
}